import { PricingType, PricingTypes } from "../../../../../common/constants";

type Options = {
  excludePerVisitPricing: boolean
}
export const getAvailablePricingTypes = (value: PricingType, options: Options) => {
  return [
    PricingTypes.TimeAndMaterials,
    PricingTypes.QuotedPrice,
    ...(!options.excludePerVisitPricing ? [PricingTypes.PerVisit] : []),
    PricingTypes.Unbillable,
    ...(value == PricingTypes.FlatRate ? [PricingTypes.FlatRate] : []),
  ]
}
